import { render, staticRenderFns } from "./SchoolSelection.vue?vue&type=template&id=9ce29d26&"
import script from "./SchoolSelection.vue?vue&type=script&lang=js&"
export * from "./SchoolSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports